<template>
<!-- Start Testimonials Area
    ============================================= -->
    <div class="testimonials-area default-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2">
            <div class="site-heading text-center">
              <h4>Nuestros Clientes nos recomiendan</h4>
            </div>
          </div>
        </div>
        <div class="testimonial-items text-center">
          <div class="row">
            <div class="col-lg-8 offset-lg-2">
              <div
                class="carousel slide"
                data-ride="carousel"
                id="testimonial-carousel"
              >
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <p>
                      Quiero referirme a la plataforma que nosotros usamos en
                      nuestra oficina “Vapp” es amigable. podemos trabajar a
                      distancia, la podemos usar a cualquier hora, guardar
                      nuestros archivos y descargarlos desdes ahi. estamos
                      agradecidos por el servicio que nos brinda, por un costo
                      que es asequible para cualquiera!
                    </p>
                    <h4>Gladys Saavedra</h4>
                    <span>Socia fundadora de Glasamu</span>
                  </div>
                  <!--<div class="carousel-item">
                                    <i class="ti-quote-left"></i>
                                    <p>
                                        Understood instrument or do connection no appearance do invitation. Dried quick round it or order. Add past see west felt did any. Say out noise you taste merry plate you share. My resolve arrived is we chamber be removal. 
                                    </p>
                                    <h4>Angelica Navarrete</h4>
                                    <span>Director of Softing</span>
                                </div>
                                <div class="carousel-item">
                                    <i class="ti-quote-left"></i>
                                    <p>
                                        Understood instrument or do connection no appearance do invitation. Dried quick round it or order. Add past see west felt did any. Say out noise you taste merry plate you share. My resolve arrived is we chamber be removal. 
                                    </p>
                                    <h4>Paul Munni</h4>
                                    <span>Developer of Softing</span>
                                </div>-->
                </div>
                <!-- End Carousel Content -->

                <!-- Carousel Indicators -->
                <ol class="carousel-indicators">
                  <li
                    data-target="#testimonial-carousel"
                    data-slide-to="0"
                    class="active"
                  >
                    <img src="assets\img\secretary.png" alt="Thumb" />
                  </li>
                  <!--<li data-target="#testimonial-carousel" data-slide-to="1">
                                    <img src="assets/img/100x100.png" alt="Thumb">
                                </li>
                                <li data-target="#testimonial-carousel" data-slide-to="2">
                                    <img src="assets/img/100x100.png" alt="Thumb">
                                </li>-->
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Testimonials Area -->
</template>


<script>
    export default {
        name: "Banner4",
        components: {},
        beforeMount() {},
    };
</script>